import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from '../../../util/axiosInstance';

// fetch

export const fetchCustomerAction = createAsyncThunk(
  'customer/fetch',
  async (customer, { rejectWithValue, getState, dispatch }) => {
    //get user token
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };
    //http call
    try {
      const { data } = await axios.get(`/customer/viewcustomers`, config);
      return data;
    } catch (error) {
      if (!error?.response) {
        throw error;
      }
      return rejectWithValue(error?.response?.data);
    }
  }
);

const customerSlices = createSlice({
  name: 'customers',
  initialState: {
    customersList: [],
  },
  extraReducers: (builder) => {
    builder
      // fetch
      .addCase(fetchCustomerAction.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(fetchCustomerAction.fulfilled, (state, action) => {
        state.customersList = action?.payload;
        state.loading = false;
        state.appErr = undefined;
        state.serverErr = undefined;
      })
      .addCase(fetchCustomerAction.rejected, (state, action) => {
        state.loading = false;
        state.appErr = action?.payload?.message;
        state.serverErr = action?.error?.message;
      });
  },
});

export default customerSlices.reducer;
